import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, shareReplay } from 'rxjs/operators';
import { HealthService } from '../services/health.service';

@Injectable({
  providedIn: 'root',
})
export class ReadinessService {
  private checkInFlight$: Observable<boolean> | null = null;

  constructor(private health: HealthService) {}

  checkReadiness(): Observable<boolean> {
    if (!this.checkInFlight$) {
      this.checkInFlight$ = this.health.getReadiness().pipe(
        map(() => true),
        catchError(() => of(false)),
        finalize(() => {
          this.checkInFlight$ = null;
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }

    return this.checkInFlight$;
  }
}
